export default __webpack_public_path__ + "static/media/190629_190332_Jason Fitzpatrick photo 4x6.4970685a.jpg";